export const SET_VISIBILITY = '[DRAWERS] SET_VISIBILITY';
